module.exports = {
    tokenLocalStorageKey:'jyw_token',
    headerTokenKey:"X-Session",
    headerTokenPrefix:'',
    rev:'',
    outputPath:'/',
    // publicPath:'/',
    publicPath:'/',
    // api:'http://reliao-dev.qiyi.domain',
    api:'http://47.94.222.0:8003',

};


// WEBPACK FOOTER //
// config/base.js